module.exports = __webpack_public_path__ + "img/INC.5ff469e.svg";